import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import CheckoutService from 'services/checkout/checkout.service';

export const getCheckoutItems = createAsyncThunk('getCheckoutItems', async ({}, thunkAPI) => {
	const { rejectWithValue, fulfillWithValue, signal } = thunkAPI;
	const source = axios.CancelToken.source();
	signal.addEventListener('abort', () => {
		source.cancel();
	});

	try {
		const {
			data: { checkout, saved_for_later, summary },
		} = await CheckoutService.instance.getCheckoutItems(source.token);
		return fulfillWithValue({ checkout, saved_for_later, summary });
	} catch (error) {
		return rejectWithValue({ error });
	}
});
